import * as types from './types';

export const getDataSourcesRequest = (data) => ({ type: types.GET_DATASOURCES_REQUEST, data });
export const getDataSourcesRequestFailure = (error) => ({ type: types.GET_DATASOURCES_REQUEST_FAILURE, error });
export const getDataSourcesRequestSuccess = (data) => ({ type: types.GET_DATASOURCES_REQUEST_SUCCESS, data });

export const updateDataSourcesRequest = (data) => ({ type: types.UPDATE_DATASOURCES_REQUEST, data });
export const updateDataSourcesRequestFailure = (error) => ({ type: types.UPDATE_DATASOURCES_REQUEST_FAILURE, error });
export const updateDataSourcesRequestSuccess = (data) => ({ type: types.UPDATE_DATASOURCES_REQUEST_SUCCESS, data });
